import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import {
  BaseBox,
  CenterBox,
  Heading4,
  PrimaryButton,
  Icons,
  DoconModal,
  DoconModalContent,
} from '@docon/docon-ui-library';
import { getTimeFromMinutes } from 'utils';
import { colors } from 'utilities/colorConfig';

interface IProps {
  doctorName?: string;
  appointmentDate: string; //"2021-07-29T00:00:00",
  appointmentTime: number;
  onClose: () => void;
}

const Content = styled(BaseBox)`
  padding: 28px 25px 40px;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.primaryColor};
  text-align: center;

  ${CenterBox} {
    margin-bottom: 15px;
    border-radius: 50%;
    color: ${colors.white};
  }

  ${Heading4} { font-weight: bold; margin-bottom: 24px; }

  > * {
    margin-left: auto;
    margin-right: auto;
  }
`;

const Modal = styled<any>(DoconModal)`
  max-width: calc(100vw - 50px);
  border-radius: 10px;

  ${DoconModalContent} {
    padding: 0;
  }
`;

const CancelSuccessful = ({
  doctorName,
  appointmentDate,
  appointmentTime,
  onClose,
}: IProps) => {

  const subHeading = `Your appointment with <b>${doctorName}</b> on <b>${moment(appointmentDate).format('DD MMM ')}</b> at <b>${getTimeFromMinutes(appointmentTime)}</b> is successfully cancelled`;
  const text = 'Any amount debited will be refunded within <b>7-10</b> working days';

  return (
    <Modal
      isOpen
      centered
      hideFooter
      hideCrossIcon
    >
      <Content>
        <CenterBox size={45} bg={colors.success}><Icons.TickIcon /></CenterBox>
        <Heading4 title={'Successfully cancelled'} />
        <BaseBox mb='10px' dangerouslySetInnerHTML={{ __html: subHeading }} />
        <BaseBox mb='24px' dangerouslySetInnerHTML={{ __html: text }} />
        <PrimaryButton
          px='50px !important'
          mx='auto !important'
          size='small'
          title={'OK'}
          onClick={onClose}
        />
      </Content>
    </Modal>
  );
};

export default CancelSuccessful;

